import fetch from '@/plugin/axios'

// 证书列表
export function certList (query) {
  console.log('certList >>', query)
  return fetch({
    url: '/api/member/certificate/list',
    method: 'Post',
    data: query
  })
}

// 证书添加
export function addCert (query) {
  return fetch({
    url: '/api/member/certificate/add',
    method: 'Post',
    data: query
  })
}

// 证书信息
export function certDetail (id) {
  return fetch({
    url: `/api/member/certificate/info/${id}`,
    method: 'Get'
  })
}

export function certDetailByName (name) {
  return fetch({
    url: `/api/member/certificate/info?name=${name}`,
    method: 'Get'
  })
}
// 修改证书
export function editCert (id, query) {
  return fetch({
    url: `/api/member/certificate/update/${id}`,
    method: 'Post',
    data: query
  })
}

// 删除证书
export function delCert (id) {
  return fetch({
    url: `/api/member/certificate/remove/${id}`,
    method: 'Get'
  })
}
